export const comment = {
    "Naam": "",
    "Email": "",
    "Comment": ""
  }